// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b826bb27","455":"1042f7fb","977":"bd64a35b"}[chunkId] + ".chunk.js";
};